import { Button } from "@flint/ui";

/**
 * A control the wireframe draws but no module can yet serve — dimmed, inert,
 * and honest about why on hover.
 *
 * Why the wrapping `<span>`: `Button`'s base class sets
 * `disabled:pointer-events-none`, so a disabled button receives no `mouseover`
 * and the browser never renders its `title`. The tooltip would be invisible on
 * the one control that most needs to explain itself. Putting the `title` on an
 * enabled parent restores the hint while the button itself stays genuinely
 * disabled — not merely styled to look it, which would still submit on Enter.
 *
 * This is the `products-list-page.tsx` "Combo pack" pattern, adapted from a
 * Radix menu item to a plain button.
 */
export function ComingSoonButton({
  label,
  reason,
  size = "md",
}: {
  label: string;
  /** What has to exist first, e.g. "PDF rendering". Reads as "… — coming soon". */
  reason: string;
  size?: "sm" | "md";
}) {
  return (
    <span title={`${reason} — coming soon`} className="inline-flex cursor-not-allowed">
      <Button intent="secondary" size={size} disabled aria-describedby={undefined}>
        {label}
      </Button>
    </span>
  );
}
